import { COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
`;

const Input = styled.input`
  font-size: 12px;
  width: 100%;
  height: 44px;
  border: 1px solid ${COLORS.GHOST};
  border-radius: 8px;
  padding: 8px;
  &:focus {
    outline: none;
  }
`;

const Label = styled(Text)`
  position: absolute;
  pointer-events: none;
  left: 12px;
  top: 12px;
  transition: 0.3s ease all;
  background: white;
  padding: 0 4px;
  top: ${props => (props.isFloating ? `-8px` : `12px`)};

  ${Input}:focus ~ & {
    top: -8px;
    left: 12px;
  }
`;

const CueTextInput = ({ label, onChange, value }) => {
  const handleChange = e => {
    onChange(e.target.value);
  };

  return (
    <Wrapper>
      <Input type="text" value={value} onChange={handleChange} />
      <Label isFloating={!!value} variant="body3" color={COLORS.SCORPION}>
        {label}
      </Label>
    </Wrapper>
  );
};

export default CueTextInput;
